import 'react-app-polyfill/ie11';
import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import Startup from './startup';

ReactDOM.render(<Startup />, document.querySelector('#startup'));
